import { createFileRoute } from '@tanstack/react-router';
import { ViewSubmissionScreen } from '@/quiz-submission/ViewSubmissionScreen';

/**
 * The member mount of the view screen. Legacy's member template is a ONE-LINE
 * `require` of the group template
 * (`themes/wbs/buddypress/members/single/course-study/quiz_view.php:1`), so the
 * screen is built once in `@/quiz-submission/` and mounted twice; this file
 * supplies nothing but the submission id.
 *
 * X8 — re-keyed from `$lessonSlug`. Every legacy deep link into this screen
 * passes the GRADING id and not one passes a slug (R37:
 * `lesson-quiz-graded-results.php:25`, `lesson-quiz-auto-graded-results.php:14`,
 * `topic-quiz-graded-results.php:8`, `content-lesson.php:96` ->
 * `CachedGradingGenerator.php:324`, `unread-feedback.php:29`,
 * `UserActionViewColumn.php:24`, `Submissions/View.php:42`,
 * `Learndash/QuizGraded.php:60-61,76`). The slug route was a v3 invention that
 * could not address 76 of the 137 rows behind the 61 (student, lesson) pairs
 * that hold more than one submission.
 *
 * R30 — `$memberId` is decorative. Authorization is on the grading, never on the
 * path segment: measured live, grading 880 renders through `/members/1613/...`
 * as well as through its own student's URL.
 */
export const Route = createFileRoute(
  '/_app/_users/members/$memberId/course-study/quizzes/view/$submissionId',
)({
  component: MemberQuizSubmissionViewScreen,
});

function MemberQuizSubmissionViewScreen() {
  const { submissionId } = Route.useParams();
  return (
    <ViewSubmissionScreen submissionId={Number.parseInt(submissionId, 10)} />
  );
}
